import React, { Component } from "react"
import PropTypes from "prop-types"
import { withRadium, ConnectLocation } from "higher-order-components"
import { invokeFuncs } from "utils/function"
import { noop, bindAll } from "utils"

const SvgPostCodeIcon = props => (
  <svg viewBox="0 0 18 18" style={{ ...styles.icon, ...(props.active ? styles.activeIcon : "") }}>
    <title>postcode</title>
    <path d="M15.5 6.5c0 2.9-1.5 5-3 7-.8 1.1-2.9 3.7-2.9 3.7L9 18l-.6-.8s-2.1-2.6-2.9-3.7c-1.5-2-3-4.1-3-7C2.5 2.9 5.4 0 9 0s6.5 2.9 6.5 6.5zm-1.5 0c0-2.8-2.2-5-5-5s-5 2.2-5 5c0 2.2 1 3.9 2.7 6.1.5.7 1.6 2 2.3 2.9.7-.9 1.7-2.2 2.3-2.9 1.7-2.3 2.7-4 2.7-6.1zm-2.9-.7c0 1.1-.9 2.1-2.1 2.1-1.1 0-2-.9-2-2s.9-2 2-2.1c1.1 0 2.1.9 2.1 2z" />
  </svg>
)

const SvgLocationIcon = () => (
  <svg
    style={{
      display: "inline-block",
      margin: "0 0 0 1em",
      width: "1em",
      height: "1em",
      fill: "currentColor"
    }}
    viewBox="0 0 14 14">
    <path d="M10.39,6l0.9,0.9L6.22,11.91,0,14,2.1,7.79,7.15,2.73,8,3.62,3.2,8.47,2.32,11.08l0.6,0.59,2.61-.88ZM4,9.4A0.63,0.63,0,0,1,4.16,9L8.77,4.34l0.9,0.9L5.05,9.85A0.63,0.63,0,0,1,4.6,10,0.65,0.65,0,0,1,4,9.4Zm10-6a1.66,1.66,0,0,1-.48,1.16L12,6.13,7.88,2,9.4,0.48a1.65,1.65,0,0,1,2.33,0l1.8,1.79A1.66,1.66,0,0,1,14,3.45Zm-1.27,0a0.37,0.37,0,0,0-.1-0.27l-1.8-1.8a0.38,0.38,0,0,0-.54,0L9.67,2,12,4.34l0.63-.63A0.35,0.35,0,0,0,12.73,3.45Z" />
  </svg>
)

/** Postcode Selector Component. */
class PostcodeSelector extends Component {
  constructor(props) {
    super(props)
    this.state = {
      active: false
    }

    bindAll(["activate", "reset", "handleClick"], this)
  }

  activate() {
    this.setState({ active: true })
  }

  reset() {
    this.setState({ active: false })
  }

  handleClick() {
    const { requestPostcodeInput } = this.props.locationActions
    const { gtmEvents } = this.props
    gtmEvents && invokeFuncs(gtmEvents)
    requestPostcodeInput()
  }

  render() {
    const { postcode } = this.props.locationState


    return (
      <span style={styles.base} data-test="postcode-selector">
        <div
          data-test="PostcodeSelector"
          style={[styles.button, this.state.active ? styles.active : ""]}
          onClick={this.handleClick}
          onMouseOver={this.activate}
          onFocus={this.activate}
          onMouseOut={this.reset}
          onBlur={this.reset}>
          <SvgPostCodeIcon active={this.state.active} />
          {postcode}
          <span style={styles.change}>
            Change my location
            <SvgLocationIcon />
          </span>
        </div>
        {this.props.children}
      </span>
    )
  }
}

export default withRadium(ConnectLocation())(PostcodeSelector)

PostcodeSelector.propTypes = {
  locationState: PropTypes.object,
  locationActions: PropTypes.object,
  children: PropTypes.node
}

PostcodeSelector.defaultProps = {
  locationState: {},
  locationActions: {
    requestPostcodeInput: noop
  }
}

const styles = {
  base: {
    display: "inline-block",
    lineHeight: "1.5em",
    position: "relative",
    whiteSpace: "nowrap"
  },
  button: {
    cursor: "pointer",
    fontWeight: 800,
    textTransform: "uppercase",
    transition: ".25s"
  },
  active: {
    color: "white"
  },
  activeIcon: {
    fill: "#910A2D"
  },
  change: {
    display: "inline-block",
    margin: "0 .5em",
    fontWeight: 200,
    fontStyle: "italic",
    textTransform: "none",
    borderBottom: "1px solid currentColor",
    "@media (min-width: 768px)": {
      display: "none"
    }
  },
  icon: {
    width: "1.5em",
    height: "1.5em",
    display: "inline-block",
    position: "relative",
    top: ".35em",
    left: "0em",
    paddingRight: "0.125em",
    fill: "rgb(153, 153, 153)",
    transition: ".25s"
  }
}



// WEBPACK FOOTER //
// ./src/containers/postcode-selector/index.jsx